import { MessageStatus } from './queries/useSearchTickets/useSearchTickets.interface';

import { isProduction } from 'modules/common/config';

/**
 * TODO (infra improvement):
 * Consider moving these hardcoded Zendesk IDs to environment-specific config (e.g., secrets manager or ENV vars).
 *
 * Rationale:
 * - Reduces risk of leaking production-specific IDs in code
 * - Makes local/staging/prod values easier to manage across environments
 * - Aligns with 12-factor app principles and keeps config decoupled from code
 *
 * Example:
 * Instead of:
 *   config.environment === 'production' ? 123 : 456
 * Use:
 *   process.env.ZENDESK_CSAT_STATUS_ID or config.zendesk.csatStatusId
 */

// ID for the custom Zendesk status used to indicate when a ticket has entered the CSAT flow.
// Statuses configured here: https://support.zendesk.com/hc/en-us/articles/4412575861018
// const BOT_STATUS_ID = config.environment === 'production' ? 35444408439955 : 31860172978708; (Currently disabled)
export const CSAT_STATUS_ID = isProduction() ? 41187425398291 : 37432410527892;

// List of Zendesk statuses we treat as “open” in the IMC.
// These tickets are still replyable by members.
export const OPEN_MESSAGES_STATUSES: MessageStatus[] = ['new', 'open', 'pending', 'hold', 'solved'];

// Status used to indicate tickets that are no longer active/replyable.
export const CLOSED_MESSAGES_STATUSES: MessageStatus[] = ['closed'];

// Zendesk custom field for capturing CSAT score.
// More on custom fields: https://support.zendesk.com/hc/en-us/articles/4420210121114
export const CSAT_SCORE_FIELD_ID = isProduction() ? 35775118546195 : 32798158974484;

// Free-text field for CSAT comments (optional feedback from member).
export const CSAT_COMMENT_FIELD_ID = isProduction() ? 35775161835283 : 32798097950868;

// Field used to track the last time a member viewed their ticket in .
// Used for analytics, routing, and notification suppression logic.
export const LAST_VIEWED_FIELD_ID = isProduction() ? 35451316145555 : 31649389263252;

// Internal-only field to track how the member rated bot suggestions. (Currently disabled)
export const BOT_CUSTOM_FIELD_ID = isProduction() ? 35801618397715 : 32798052343188;

// Allowed values for the bot feedback field (Currently disabled, keep for consistency).
export const BOT_CUSTOM_FIELD_VALUES = {
    NO_SUGGESTIONS: 'no_suggestions', // Bot didn’t offer anything actionable
    HELPFUL: 'helpful', // Member found the suggestion useful
    NOT_HELPFUL: 'not_helpful', // Member found the suggestion unhelpful
};

// Display name used for the bot in member-facing messages.
export const BOT_NAME = 'Collective Concierge';

// Author ID for messages sent by the bot Collective Concierge in Zendesk.
// Needed to distinguish bot replies from human agents in the IMC.
export const BOT_AUTHOR_ID = isProduction() ? 35582849261075 : 37434838003860;
